import { Settings } from 'luxon'

Settings.defaultLocale = 'ja'
